// extracted by mini-css-extract-plugin
export var dropdownIcon = "_m1-6";
export var imgContainer = "_m1-3";
export var menuIcon = "_m1-5";
export var pillWrapper = "_m1-2";
export var pillsContainer = "_m1-1";
export var subscriptionCard = "_m1-0";
export var subscriptionLogo = "_m1-4";